// 仓内看板 - GraphQL 与前端组件共享的枚举 / 基础类型
// 与后端 `dto/InhubDashboard.kt` 的枚举一一对应

export type InhubDataFreshness = 'REALTIME' | 'T1';
export type InhubWowSeverity = 'NONE' | 'WARN' | 'DANGER';

export type InhubSortingMetric =
    | 'INBOUND_COUNT'
    | 'BAGGING_COUNT'
    | 'LOADING_PARCEL_COUNT'
    | 'WRONG_ROUTE_BAGGING_COUNT'
    | 'WRONG_SORT_COUNT'
    | 'ASCAN_MISS_COUNT'
    | 'TRANSIT_IN_MISS_COUNT';

export type InhubSortingDimension = 'TEAM' | 'ACCOUNT';

export type InhubTransportPerspective = 'OUTBOUND' | 'INBOUND';

export type InhubBaggingDestBucket = 'HUB' | 'WHS';

// 前端 KPI 卡片 / 表头按驼峰命名查找的 key（沿用历史 mock 命名以减少 UI 改动）
export type SortingMetricKey =
    | 'inboundCount'
    | 'baggingCount'
    | 'loadingParcelCount'
    | 'wrongRouteBaggingCount'
    | 'wrongSortCount'
    | 'ascanMissCount'
    | 'transitInMissCount';

export const METRIC_TO_KEY: Record<InhubSortingMetric, SortingMetricKey> = {
    INBOUND_COUNT: 'inboundCount',
    BAGGING_COUNT: 'baggingCount',
    LOADING_PARCEL_COUNT: 'loadingParcelCount',
    WRONG_ROUTE_BAGGING_COUNT: 'wrongRouteBaggingCount',
    WRONG_SORT_COUNT: 'wrongSortCount',
    ASCAN_MISS_COUNT: 'ascanMissCount',
    TRANSIT_IN_MISS_COUNT: 'transitInMissCount'
};

export const KEY_TO_METRIC: Record<SortingMetricKey, InhubSortingMetric> = {
    inboundCount: 'INBOUND_COUNT',
    baggingCount: 'BAGGING_COUNT',
    loadingParcelCount: 'LOADING_PARCEL_COUNT',
    wrongRouteBaggingCount: 'WRONG_ROUTE_BAGGING_COUNT',
    wrongSortCount: 'WRONG_SORT_COUNT',
    ascanMissCount: 'ASCAN_MISS_COUNT',
    transitInMissCount: 'TRANSIT_IN_MISS_COUNT'
};

export interface InhubKpiCell {
    value: number;
    wowPercent: number;
    freshness: InhubDataFreshness;
    severity: InhubWowSeverity;
    isNegativeIndicator: boolean;
}
